
document.addEventListener("DOMContentLoaded", function () {
    let _promotionDateListElementValues = [];
    let _promotionLeftPositionPx = 0;
    let _constExtraPercentageSpace = 1;
    let _constNumberOfExtraMonthColumns = 1;
    let _promotionListMonthAltWidth = 0;
    const _classNamePromotionListMonthAlt = '.promotion-list__month.promotion-list__month--alt';
    const _classNamePromotionListMonthPlannerContainer = '.promotion-list__month--planner__container';
    const _classNamePromotionListDate = '.promotion-list__promotion-date.promotion-list__promotion-date--plan';
    const _classNameBodyRowsSyncScroll = '.body_rows.syncscroll';
    // =========================================================== usyncScroll
    const Width = 'Width';
    const Height = 'Height';
    const Top = 'Top';
    const Left = 'Left';
    const scroll = 'scroll';
    const client = 'client';
    const EventListener = 'EventListener';
    const addEventListener = 'add' + EventListener;
    const length = 'length';
    const Math_round = Math.round;
    var names = {};

    const _reset = function () {
        var elems = document.getElementsByClassName('sync' + scroll);

        // clearing existing listeners
        var i, j, el, found, name;
        for (name in names) {
            if (names.hasOwnProperty(name)) {
                for (i = 0; i < names[name][length]; i++) {
                    names[name][i]['remove' + EventListener](
                        scroll, names[name][i].syn, 0
                    );
                }
            }
        }

        // setting-up the new listeners
        for (i = 0; i < elems[length];) {
            found = j = 0;
            el = elems[i++];
            if (!(name = el.getAttribute('name'))) {
                // name attribute is not set
                continue;
            }

            el = el[scroll + 'er'] || el;  // needed for intence

            // searching for existing entry in array of names;
            // searching for the element in that entry
            for (; j < (names[name] = names[name] || [])[length];) {
                found |= names[name][j++] == el;
            }

            if (!found) {
                names[name].push(el);
            }

            el.eX = el.eY = 0;

            (function (el, name) {
                el[addEventListener](
                    scroll,
                    el.syn = function () {
                        var elems = names[name];

                        var scrollX = el[scroll + Left];
                        var scrollY = el[scroll + Top];

                        var xRate =
                            scrollX /
                            (el[scroll + Width] - el[client + Width]);
                        var yRate =
                            scrollY /
                            (el[scroll + Height] - el[client + Height]);

                        var updateX = scrollX != el.eX;
                        var updateY = scrollY != el.eY;

                        var otherEl, i = 0;

                        el.eX = scrollX;
                        el.eY = scrollY;

                        for (; i < elems[length];) {
                            otherEl = elems[i++];
                            if (otherEl != el) {
                                if (updateX &&
                                    Math_round(
                                        otherEl[scroll + Left] -
                                        (scrollX = otherEl.eX =
                                            Math_round(xRate *
                                                (otherEl[scroll + Width] -
                                                    otherEl[client + Width]))
                                        )
                                    )
                                ) {
                                    otherEl[scroll + Left] = scrollX;
                                    _promotionLeftPositionPx = scrollX;
                                    _setPromotionLeftWidth();
                                }

                                if (updateY &&
                                    Math_round(
                                        otherEl[scroll + Top] -
                                        (scrollY = otherEl.eY =
                                            Math_round(yRate *
                                                (otherEl[scroll + Height] -
                                                    otherEl[client + Height]))
                                        )
                                    )
                                ) {
                                    otherEl[scroll + Top] = scrollY;
                                }
                            }
                        }
                    }, 0
                );
            })(el, name);
        }
    }
    // =========================================================== usyncScroll

    let _setConstantValue = function () {
        const _bodyRowsSyncScroll = document.querySelector(_classNameBodyRowsSyncScroll);

        if (_bodyRowsSyncScroll) {
            const _children = _bodyRowsSyncScroll.children;
            const _percentage = _children[0].offsetWidth / _bodyRowsSyncScroll.offsetWidth;
            _constNumberOfExtraMonthColumns = Math.round(_children.length * +_percentage.toFixed(4));
        }

        const _promotionListMonthAlt = document.querySelector(_classNamePromotionListMonthAlt);
        const _promotionListMonthPlannerContainer = document.querySelector(_classNamePromotionListMonthPlannerContainer);
        if (_promotionListMonthAlt && _promotionListMonthPlannerContainer) {
            _promotionListMonthAltWidth = _promotionListMonthAlt.offsetWidth;
            const _diff = _promotionListMonthPlannerContainer.offsetWidth / _promotionListMonthAltWidth;

            _constExtraPercentageSpace = Math.abs(Math.round(_diff * 100));
        }
    }

    let _getPromotionDates = function () {
        const promotions = document.querySelectorAll(_classNamePromotionListDate);

        return promotions || [];
    }

    let _setPromotionValues = function (_promotions) {
        if (_promotions && _promotions.length > 0) {
            _promotions.forEach(function (_promotion) {
                _promotionDateListElementValues.push({
                    'elem': _promotion,
                    'dayStart': +_promotion.getAttribute('data-days-from-start'),
                    'dayEnd': +_promotion.getAttribute('data-days-from-start-end'),
                    'totalStart': +_promotion.getAttribute('data-total-days')
                });
            })
        }
    }

    let _setPromotionLeftWidth = function () {
        if (_promotionDateListElementValues && _promotionDateListElementValues.length > 0) {
            for (var i = 0; i < _promotionDateListElementValues.length; i++) {
                const _val = _promotionDateListElementValues[i];
                const _extraSpaceBox = 100;

                let _leftPositionPerc = (Math.abs(_promotionLeftPositionPx) / _promotionListMonthAltWidth) * 100;

                let _percentageStart = (+_val.dayStart / +_val.totalStart) * _constExtraPercentageSpace * _constNumberOfExtraMonthColumns;
                _percentageStart += _extraSpaceBox - _leftPositionPerc;
                if (_percentageStart > (_extraSpaceBox + _constExtraPercentageSpace - 5)) {
                    _percentageStart = _extraSpaceBox + _constExtraPercentageSpace - 5;
                } else if (_percentageStart < 5) {
                    _percentageStart = 5;
                }

                let _percentageEnd = (+_val.dayEnd / +_val.totalStart) * _constExtraPercentageSpace * _constNumberOfExtraMonthColumns;
                _percentageEnd += _extraSpaceBox - _leftPositionPerc;
                if (_percentageEnd > (_extraSpaceBox + _constExtraPercentageSpace)) {
                    _percentageEnd = _extraSpaceBox + _constExtraPercentageSpace;
                } else if (_percentageEnd < 40) {
                    _percentageEnd = 40;
                }

                const _left = `${_percentageStart}%`;
                let _width = `${_percentageEnd - _percentageStart}%`;

                _val.elem.style.setProperty('--left', _left);
                _val.elem.style.setProperty('--width', _width);
            }
        }
    }

    let _init = function () {
        _setConstantValue();
        _reset();
        const _promotions = _getPromotionDates();
        _setPromotionValues(_promotions);
        _setPromotionLeftWidth();
    }

    if (document.readyState == "complete") {
        _init();
    } else {
        window['addEventListener']("load", _init, 0);
        window['addEventListener']("resize", _init, 0);
    }
});
